<div class="batch-container">
  <h2 class="batch-title">Batch List</h2>

  <div class="filter-bar">
    <input
      type="text"
      class="search-input"
      placeholder="Search by user..."
      [(ngModel)]="searchTerm"
      (ngModelChange)="(searchTerm)"
    />

    <select
      class="status-select"
      [(ngModel)]="selectedStatus"
      (ngModelChange)="onStatusChange($event)"
    >
      <option value="Pending">Pending</option>
      <option value="InProgress">InProgress</option>
      <option value="Completed">Completed</option>
      <option value="Cancelled">Cancelled</option>
      <option value="PartialComplete">PartialComplete</option>
    </select>

    <select
      *ngIf="!isStoreUser"
      class="status-select"
      [(ngModel)]="selectedStoreId"
      (ngModelChange)="onStoreChange($event)"
    >
      <option [ngValue]="null">All Stores</option>

      <option *ngFor="let store of stores" [ngValue]="store.storeId">
        {{ store.name }}
      </option>
    </select>
  </div>

  <ng-container #loadingState *ngIf="loading; else batchContent">
    <div class="loading">
      <div class="scanner-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          class="bi bi-upc-scan me-2 scanner-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z"
          />
        </svg>
        <div class="scanner-line"></div>
      </div>
    </div>
  </ng-container>

  <ng-template #batchContent>
    <table *ngIf="filteredBatches.length > 0" class="batch-table">
      <thead>
        <tr>
          <th>User</th>
          <th>Status</th>
          <th>Creation Date</th>
          <th>Detail</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let batch of filteredBatches"
          (click)="batch.status !== 'Completed' && openBatchDetailModal(batch)"
        >
          <!-- <tr *ngFor="let batch of filteredBatches" (click)="openBatchDetailModal(batch)"> -->
          <td>
            <ng-container *ngIf="getUserDisplay(batch.userName) as userInfo">
              <div>{{ userInfo.name }}</div>
              <small *ngIf="userInfo.email">{{ userInfo.email }}</small>
            </ng-container>
          </td>
          <td>{{ batch.status }}</td>
          <td>
            {{ batch.createdAt | date: "medium" }}
            <b *ngIf="batch.status == 'Pending'">{{
              calculatePendingTime(batch.createdAt)
            }}</b>
            <!-- <b *ngIf="batch.status == 'Completed'">{{ calculatePendingTime(batch.createdAt) }}</b> -->
          </td>
          <td>
            <div>
              Prescriptions: <strong>{{ batch.prescriptions.length }}</strong>
            </div>
            <div>
              Medications: <strong>{{ getMedicationCount(batch) }}</strong>
            </div>
          </td>
          <td>
            <button
              *ngIf="
                (batch.status.toLowerCase() == 'pending' ||
                  batch.status.toLowerCase() == 'inprogress' ||
                  batch.status.toLowerCase() == 'partialcomplete') &&
                isStoreUser
              "
              (click)="printPickList(batch.batchId)"
              style="background-color: green; margin-right: 5px"
            >
              Print Pick-List
            </button>
            <button
              *ngIf="
                (batch.status.toLowerCase() == 'pending' ||
                  batch.status.toLowerCase() == 'inprogress' ||
                  batch.status.toLowerCase() == 'partialcomplete') &&
                isStoreUser
              "
              (click)="scanBatch(batch.batchId)"
            >
              Start Scan
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="no-batches" *ngIf="filteredBatches.length === 0">
      No batch found.
    </div>
  </ng-template>
</div>
<!-- Pagination buttons -->
<div
  class="pagination-buttons"
  *ngIf="!loading && totalPages > 1 && filteredBatches.length > 0"
>
  <button
    class="btn btn-secondary"
    style="
      margin-right: 5px;
      --bs-btn-padding-y: 0.25rem;
      --bs-btn-padding-x: 0.5rem;
      --bs-btn-font-size: 0.75rem;
    "
    (click)="getAllBatch(currentPage - 1)"
    [disabled]="currentPage === 1"
  >
    Previous
  </button>

  <button
    class="btn btn-secondary"
    style="
      --bs-btn-padding-y: 0.25rem;
      --bs-btn-padding-x: 0.5rem;
      --bs-btn-font-size: 0.75rem;
    "
    (click)="getAllBatch(currentPage + 1)"
    [disabled]="currentPage >= totalPages"
  >
    Next
  </button>
</div>
<!-- print section -->
<!-- <div id="printlist" class="printlist" #printSection style="display: none">
  <div class="container">
    <h2>Batch pickup list</h2>
    <table cellpadding="10">
      <thead>
        <tr>
          <th>Stock Item</th>
          <th>Prescription ID</th>
          <th>Quantity</th>
          <th>Picked Y/N?</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let medication of objectKeys(groupedMedications)">
          <td>{{ medication }}</td>
          <td>
            {{ groupedMedications[medication].prescriptionIds.join(", ") }}
          </td>
          <td>{{ groupedMedications[medication].quantity }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->

<div id="printlist" class="printlist" #printSection style="display: none">
  <div class="print-container">
    <!-- TOP BAR (DATE + LOGOS) -->
    <div class="print-top-bar">
      <div class="print-date">
        {{ todayDate }}
      </div>
      <div class="print-logos">
        <img src="../../assets/images/mclernons.png" class="print-logo" />
        <img src="../../assets/images/safescan.png" class="print-logo" />
      </div>
    </div>

    <!-- THIN LINE BELOW HEADER -->
    <hr style="border: none; border-top: 1px solid #e0e0e0; margin: 6px 0 12px 0;" />

    <h2 class="print-title">Batch Pick List</h2>

    <table class="print-table">
      <thead>
        <tr>
          <th class="col-stock">Stock Item</th>
          <th class="col-prescription">Prescription ID</th>
          <th class="col-qty">Quantity</th>
          <th class="col-picked">Picked Y/N</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let medication of objectKeys(groupedMedications)">
          <td>{{ medication }}</td>
          <td>
            Ending -{{ getLastChars(groupedMedications[medication].prescriptionIds?.[0]) }}
          </td>
          <td>{{ groupedMedications[medication].quantity }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<!-- Modal -->
<div
  class="modal fade"
  id="batchDetailModal"
  tabindex="-1"
  aria-labelledby="batchDetailModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content custom-modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Current Batch Details: {{ selectedBatch?.batchId }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <!-- Current Batch Details Template -->
        <div class="batch-card" *ngIf="selectedBatch">
          <!-- <h2 class="current-batch-title">Current Batch Details</h2> -->
          <div class="summary-container">
            <div class="summary-box">
              <div class="summary-content">
                <div class="summary-label">Prescriptions</div>
                <div class="summary-value">
                  {{ selectedBatch.prescriptions.length }}
                </div>
              </div>
              <div class="summary-icon document-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14 3v4a1 1 0 0 0 1 1h4M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z"
                  />
                </svg>
              </div>
            </div>

            <div class="summary-box">
              <div class="summary-content">
                <div class="summary-label">Medications</div>
                <div class="summary-value">
                  {{ getMedicationCount(selectedBatch) }}
                </div>
              </div>
              <div class="summary-icon pill-icon">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.5l8-8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1-7-7z"/>
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 8.5l7 7"/>
                </svg> -->
                <svg
                  fill="#000000"
                  height="30px"
                  width="30px"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 512 512"
                  xml:space="preserve"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <g>
                        <path
                          d="M252.646,66.22c-2.362-2.363-4.75-4.853-7.06-7.26c-7.423-7.739-15.1-15.741-24.343-22.253 c-13.088-9.221-29.039-14.503-44.916-14.869c-9.382-0.216-18.719,1.238-27.728,4.323c-4.189,1.433-6.423,5.992-4.989,10.181 c1.434,4.189,5.992,6.423,10.18,4.989c7.216-2.47,14.665-3.632,22.167-3.462c12.731,0.294,25.534,4.536,36.049,11.946 c7.979,5.622,14.795,12.726,22.01,20.247c2.365,2.466,4.812,5.016,7.29,7.496c1.566,1.566,3.618,2.349,5.67,2.349 c2.051,0,4.102-0.782,5.668-2.347C255.774,74.427,255.776,69.351,252.646,66.22z"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M271.558,85.619c-1.641-1.696-3.273-3.401-4.893-5.116c-1.985-2.099-0.692-0.732-0.003-0.003 c-3.041-3.213-8.113-3.356-11.331-0.313c-3.217,3.042-3.358,8.116-0.316,11.332c1.663,1.758,3.336,3.507,5.018,5.247 c3.264,3.376,8.898,3.167,11.913-0.431C274.545,93.233,274.37,88.528,271.558,85.619z"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M464.619,247.961L355.786,139.126L246.951,30.291c-39.803-39.803-104.57-39.803-144.373,0 c-39.794,39.795-39.794,104.555,0.001,144.362l108.839,108.828c0.002,0.002,0.003,0.003,0.005,0.005l108.836,108.846 c19.903,19.896,46.044,29.845,72.183,29.845s52.28-9.949,72.177-29.846C504.422,352.529,504.422,287.763,464.619,247.961z M453.281,380.995c-33.543,33.544-88.132,33.544-121.686,0L228.429,277.818l52.975-52.974c3.131-3.131,3.131-8.207,0-11.337 c-3.131-3.131-8.206-3.131-11.338,0l-52.975,52.974L113.915,163.316c-33.544-33.555-33.544-88.143,0-121.688 c33.552-33.553,88.146-33.553,121.698,0l103.165,103.166l-45.158,45.158c-2.853,2.853-3.114,7.54-0.585,10.687 c2.948,3.667,8.593,3.979,11.922,0.651l45.156-45.156l103.166,103.165C486.834,292.85,486.834,347.443,453.281,380.995z"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M488.604,23.898c-0.013-0.014-0.027-0.026-0.04-0.039c-0.011-0.012-0.019-0.025-0.031-0.036 c-0.032-0.034-0.068-0.064-0.101-0.097c-0.03-0.031-0.056-0.065-0.087-0.096c-31.463-31.44-82.652-31.432-114.11,0.023 c-31.315,31.316-31.437,82.333-0.308,113.807c0.015,0.015,0.028,0.032,0.042,0.047c0.02,0.02,0.042,0.041,0.062,0.062 c0.005,0.005,0.01,0.011,0.015,0.016c0.003,0.003,0.006,0.005,0.009,0.009c0.092,0.095,0.185,0.19,0.282,0.283 c15.227,15.18,35.451,23.539,56.96,23.539c21.557,0,41.823-8.396,57.061-23.64C503.604,122.537,512,102.272,512,80.714 C512,59.272,503.694,39.11,488.604,23.898z M477.02,126.439c-12.211,12.215-28.449,18.943-45.722,18.943 c-14.689,0-28.617-4.881-39.969-13.848c19.474-19.804,50.436-50.135,50.779-50.472c3.163-3.098,3.216-8.174,0.118-11.337 c-3.096-3.162-8.173-3.217-11.337-0.119c-0.344,0.337-31.211,30.577-50.83,50.522c-19.499-25.335-17.659-61.964,5.517-85.14 c23.238-23.239,59.909-25.042,85.254-5.437c-9.774,9.515-21.831,21.77-22.455,22.405c-2.889,2.938-3.046,7.738-0.353,10.856 c3.022,3.499,8.543,3.683,11.785,0.387c0.153-0.155,12.631-12.839,22.4-22.345c8.911,11.332,13.761,25.218,13.761,39.859 C495.967,97.988,489.239,114.226,477.02,126.439z"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M283.134,374.252c-15.24-15.246-35.505-23.642-57.063-23.642c-21.448,0-41.616,8.31-56.829,23.409 c-0.042,0.037-0.078,0.081-0.119,0.12c-0.045,0.043-0.093,0.08-0.138,0.124c-31.441,31.465-31.431,82.654,0.022,114.109 c15.715,15.715,36.384,23.576,57.062,23.573c20.537-0.002,41.081-7.761,56.764-23.282c0.012-0.011,0.025-0.02,0.036-0.032 c0.013-0.012,0.032-0.032,0.045-0.045c0.009-0.009,0.017-0.016,0.026-0.025c0.001-0.001,0.001-0.001,0.002-0.002 c0.002-0.002,0.005-0.004,0.008-0.006c0.006-0.006,0.012-0.013,0.018-0.019c0.088-0.084,0.175-0.168,0.283-0.282 c15.171-15.224,23.521-35.439,23.521-56.94C306.772,409.754,298.376,389.489,283.134,374.252z M276.964,471.188l-57.202-57.407 c-3.125-3.137-8.202-3.145-11.337-0.02c-3.136,3.125-3.145,8.202-0.02,11.338l57.175,57.38 c-11.59,8.954-25.543,13.448-39.51,13.446c-16.566-0.001-33.135-6.3-45.723-18.889c-23.285-23.285-25.048-60.055-5.322-85.402 c5.038,5.051,10.35,10.402,10.427,10.479c1.568,1.579,3.629,2.369,5.69,2.369c2.042,0,4.084-0.775,5.647-2.327 c3.143-3.119,3.162-8.195,0.043-11.337c-0.077-0.077-5.411-5.45-10.474-10.526c11.305-8.839,25.135-13.647,39.713-13.647 c17.273,0,33.512,6.728,45.724,18.945c12.216,12.211,18.944,28.449,18.944,45.722 C290.739,445.959,285.884,459.853,276.964,471.188z"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <path
                            d="M137.963,229.071c-0.002-0.002-0.004-0.003-0.005-0.005c-0.002-0.002-0.003-0.003-0.004-0.005 c-0.015-0.015-0.031-0.027-0.046-0.042c-0.021-0.02-0.039-0.044-0.06-0.064c-0.028-0.028-0.055-0.055-0.073-0.074 c-15.246-15.245-35.513-23.641-57.071-23.641s-41.824,8.396-57.062,23.64C8.396,244.119,0,264.384,0,285.942 c0,21.442,8.306,41.604,23.396,56.816c0.042,0.046,0.089,0.086,0.131,0.13c0.041,0.043,0.076,0.089,0.118,0.13 c0.002,0.002,0.004,0.004,0.007,0.006l0.001,0.001c15.728,15.716,36.383,23.572,57.043,23.572 c20.669,0,41.342-7.866,57.077-23.596C169.13,311.646,169.215,260.536,137.963,229.071z M126.436,331.665 c-11.631,11.627-5.856,5.853-0.052,0.049c-23.291,23.232-60.025,24.984-85.355,5.28l47.542-47.447 c3.134-3.128,3.139-8.204,0.012-11.337c-3.128-3.135-8.204-3.139-11.337-0.012l-47.559,47.464 c-8.843-11.306-13.654-25.139-13.654-39.721c0-17.273,6.728-33.512,18.946-45.725c12.211-12.215,28.449-18.943,45.723-18.943 c14.659,0,28.564,4.86,39.889,13.775L98.101,257.47c-2.857,2.849-3.127,7.536-0.601,10.686c2.943,3.672,8.586,3.992,11.92,0.669 l22.46-22.39c19.56,25.32,17.76,61.975-5.395,85.179C132.269,325.83,137.983,320.118,126.436,331.665z"
                          ></path>
                          <path
                            d="M126.436,331.665c0.017-0.017,0.032-0.035,0.049-0.052c-0.034,0.034-0.067,0.067-0.101,0.101 C126.401,331.697,126.419,331.682,126.436,331.665z"
                          ></path>
                        </g>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M357.01,199.896c-14.145,0-25.653,11.509-25.653,25.653c0,14.145,11.509,25.653,25.653,25.653 s25.653-11.509,25.653-25.653C382.664,211.405,371.155,199.896,357.01,199.896z M357.01,235.169c-5.305,0-9.62-4.316-9.62-9.62 c0-5.304,4.315-9.62,9.62-9.62s9.62,4.316,9.62,9.62C366.63,230.853,362.315,235.169,357.01,235.169z"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M357.01,311.061c-14.145,0-25.653,11.509-25.653,25.653c0,14.145,11.509,25.653,25.653,25.653 s25.653-11.509,25.653-25.653C382.664,322.57,371.155,311.061,357.01,311.061z M357.01,346.334c-5.305,0-9.62-4.316-9.62-9.62 c0-5.304,4.315-9.62,9.62-9.62s9.62,4.316,9.62,9.62C366.63,342.018,362.315,346.334,357.01,346.334z"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M305.704,247.996c-18.272,0-33.136,14.865-33.136,33.136s14.864,33.136,33.136,33.136s33.136-14.865,33.136-33.136 S323.975,247.996,305.704,247.996z M305.704,298.234c-9.43,0-17.102-7.672-17.102-17.102c0-9.43,7.673-17.102,17.102-17.102 s17.102,7.673,17.102,17.102C322.806,290.562,315.133,298.234,305.704,298.234z"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M406.18,243.72c-20.04,0-36.342,16.303-36.342,36.342c0,20.04,16.303,36.342,36.342,36.342s36.342-16.303,36.342-36.342 C442.522,260.023,426.219,243.72,406.18,243.72z M406.18,300.372c-11.199,0-20.309-9.11-20.309-20.309s9.11-20.309,20.309-20.309 s20.309,9.11,20.309,20.309S417.378,300.372,406.18,300.372z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="button-container" *ngIf="isStoreUser">
              <button
                class="btn print-btn"
                (click)="printPickList(selectedBatch.batchId)"
              >
                Print Pick-List
              </button>
              <button
                class="btn scan-btn"
                (click)="scanBatch(selectedBatch.batchId)"
              >
                Start Scan
              </button>
            </div>
          </div>

          <!-- <div class="patient-list">
            <div class="patient-item" *ngFor="let patient of summary.patientSummaries">
              <div class="patient-name">{{ patient.patientName }}:</div>
              <div class="patient-medications">
                {{ patient.medicationCount }} Medications
              </div>
            </div>
          </div> -->
          <!-- after adding toggle -->
          <div class="patient-list">
            <div
              class="patient-item"
              *ngFor="let patient of summary.patientSummaries"
            >
              <!-- Patient header -->
              <div class="patient-header" (click)="togglePatient(patient)">
                <strong>{{ patient.patientName }}</strong>

                <span class="click-toggle">
                  {{ patient.expanded ? "Hide" : "Click here" }}
                </span>
              </div>

              <!-- Collapsible medicine list -->
              <div *ngIf="patient.expanded" class="medicine-collapse">
                <div
                  *ngFor="let med of patient.medications"
                  class="medicine-row"
                >
                  <span> {{ med.medicationName }} {{ med.dosage }} </span>

                  <span
                    [ngClass]="
                      med.isAvailable ? 'status-scanned' : 'status-pending'
                    "
                  >
                    {{ med.isAvailable ? "SCANNED" : "PENDING" }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
